export const knowledgeQuizStoreKey = 'knowledgeQuiz';
